/* ========== 対象処理 ========== */
// 購入履歴ページ

document.addEventListener("DOMContentLoaded", function () {
  const orderArea = document.querySelector('.account-purchaseHistory');
  const now = new Date();
  const year = now.getFullYear();
  var page = 1;
  var current = 1;

  // 購入履歴ページ
  if (orderArea) {
    setYear(year);
    setOrderHistory(year,page,current);

    // 表示年選択
    document.addEventListener("change", async (e) => {
      if (!e.target || !e.target.value) {
        return false;
      }

      setOrderHistory(e.target.value,page,current);
    });


    // 注文詳細開閉
    document.addEventListener('click', function(e) {
      if (!e.target) {
        return false;
      }

      // ボタンエリアクリック
      if (e.target.classList.contains('_open')) {
        e.target.parentNode.classList.add('open');
        return false;
      }
      if (e.target.classList.contains('_close')) {
        e.target.parentNode.classList.remove('open');
        return false;
      }
      // ボタンエリア内のspanタグ直接クリック
       if (e.target.parentNode.classList.contains('_open')) {
         e.target.parentNode.parentNode.classList.add('open');
         return false;
       }
      if (e.target.parentNode.classList.contains('_close')) {
        e.target.parentNode.parentNode.classList.remove('open');
        return false;
      }
    });
  }
});

/**
 * 購入履歴欄表示
 *
 * @param {string} year
 */
const setOrderHistory = async (year,page,currentPage) => {
  currentPage = page;
  const url = new URL(`${APP_PROXY_URL}/api/customer/payments`);
  url.searchParams.set('history_type', 1);
  url.searchParams.set('display_method', 1);
  url.searchParams.set('year', year);//year
  url.searchParams.set('number_of_data_unit', 20);//100
  url.searchParams.set('page_number', page);
  // crm の orders
  const ret = await getPaymentHistories(url.href);

  if (!ret) {
    return;
  }

  const crmOrders = ret.purchaseHistories;
  const totalOrderNum = ret.numberOfRecords;

  // shopifyのorders
  const shopifyOrders = getShopifyOrders();

  // merge crm orders, shopify orders
  const orders = mergeCustomerOrders(crmOrders, shopifyOrders, 1);

  if (!orders) {
    return;
  }

  // 複数回キャンセル or 返品された時のための対応
  // 通常購入履歴は残す
  // 通常購入履歴以外は重複削除する
  // 最初のreverse()：一番古い履歴を残したいが新着順のため逆転する
  // 最後のreverse()：新着順に並び直す
  const distinctOrders = orders.reverse().filter((order, i, self) =>
                          !isShopifyOrder(order.storeId) ||
                          !isCancelOrder(order.isStatus) ||
                          self.findIndex(e =>
                            e.receiptNumber === order.receiptNumber &&
                            isShopifyOrder(e.storeId) &&
                            isCancelOrder(e.isStatus)
                          ) === i
                        ).reverse();

  // 突合失敗注文の注文番号フォールバック取得（IM_DEV-666）
  // 重複除去後・描画前に、13桁IDのまま残ったEC注文の7桁注文番号を取得して上書きする
  await applyOrderNameFallback(distinctOrders);

  setOrderHistoryList(distinctOrders);
  setOrderHistoryItemList(totalOrderNum,year,currentPage);
};

/**
 * 購入履歴欄作成
 *
 * @param {*} histories
 */
const setOrderHistoryList = (histories) => {
  let orderList = document.querySelector('.account-purchaseHistory ._list');

  while (orderList.firstChild) {
    orderList.removeChild(orderList.firstChild);
  }
  
  if (histories.length == 0) {
    //return;
    let orderItem = document.createElement('div');
    orderItem.innerText = 'ご購入履歴がありません';
    orderItem.className = 'noHistoryMessage';
    orderList.appendChild(orderItem);
  }

  histories.forEach(history => {
    let orderItem = document.createElement('div');
    orderItem.className = isCancelOrder(history.isStatus) ? '_order off' : '_order';

    orderItem.appendChild(setOrderInfoArea(history));
    orderItem.appendChild(setOrderPriceArea(history));
    orderItem.appendChild(setOrderDetailArea(history));
    orderItem = setToggleButtonArea(orderItem);
    orderList.appendChild(orderItem);
  });
};

/**
 * 購入店舗情報欄作成
 *
 * @param {*} history
 * @returns
 */
const setOrderInfoArea = (history) => {
  let orderInfo = document.createElement('div');
  let orderData = document.createElement('p');
  let orderStore = document.createElement('div');
  let storeNameTitle = document.createElement('span');
  let storeName = document.createElement('p');
  let orderNumber = document.createElement('p');
  let numberTitle = document.createElement('span');
  let number = document.createElement('span');
  let spanSendStatus = document.createElement('span');

  orderInfo.className = '_info';
  orderData.className = '_date';
  orderData.innerText = formatDate(history.purchaseDate);
  orderStore.className = '_store';
  orderStore.style.display = 'flex';
  storeNameTitle.innerText = '購入店舗';
  storeName.innerHTML = history.storeName;
  orderNumber.className = '_number';
  numberTitle.innerText = '注文番号';
  number.innerText = isShopifyOrder(history.storeId) ? history.orderName : history.receiptNumber;

  orderStore.appendChild(storeNameTitle);
  orderStore.appendChild(storeName);
  orderNumber.appendChild(numberTitle);
  orderNumber.appendChild(number);
  orderInfo.appendChild(orderData);
  orderInfo.appendChild(orderStore);
  orderInfo.appendChild(orderNumber);

  // shopifyでの購入の場合
  if (isShopifyOrder(history.storeId)) {
    let orderSend = document.createElement('div');
    orderSend.className = isCancelOrder(history.isStatus) ? '_cancel' : '_send';

    // キャンセル注文の場合
    if (isCancelOrder(history.isStatus)) {
      orderSend.innerText = '注文取り消し';
    } else {
      spanSendStatus.innerText = getFullfilmentStates(history);
      orderSend.appendChild(spanSendStatus);
    }

    orderInfo.appendChild(orderSend);
  }

  return orderInfo;
};

/**
 * 購入価格欄作成
 *
 * @param {*} history
 * @returns
 */
const setOrderPriceArea = (history) => {
  let orderPrice = document.createElement('div');
  let divPrice1 = document.createElement('div');
  let price1Title = document.createElement('p');
  let price1 = document.createElement('p');
  let divPrice2 = document.createElement('div');
  let price2Title = document.createElement('p');
  let price2 = document.createElement('p');
  let divPrice3 = document.createElement('div');
  let price3Title = document.createElement('p');
  let price3 = document.createElement('p');
  let divPrice4 = document.createElement('div');
  let price4Title = document.createElement('p');
  let price4 = document.createElement('p');
  let divPrice5 = document.createElement('div');
  let price5Title = document.createElement('p');
  let price5 = document.createElement('p');
  let divPrice6 = document.createElement('div');
  let price6Title = document.createElement('p');
  let price6 = document.createElement('p');

  orderPrice.className = '_price';
  price1Title.innerText = '税抜合計';
  price1.innerText = convertMoneyFormat(history.purchaseSubtotalAmt);
  price2Title.innerText = '消費税';
  price2.innerText = setTaxPrice(history);
  price3Title.innerText = '送料';
  price3.innerText = isShopifyOrder(history.storeId) ? convertMoneyFormat(history.shippingFee) : 'ー 円';
  price4Title.innerText = 'ポイント利用';
  price4.innerText = setUsedPoint(history);
  divPrice5.className = '_total';
  price5Title.innerText = '税込合計';
  price5.innerText = convertMoneyFormat(history.purchaseTotalAmt);

  // ポイント計算
  history.newPoint = setNewPoint(history);
  price6Title.innerText = getPointLabel(history);
  price6.innerText = Number(history.newPoint).toLocaleString();

  divPrice1.appendChild(price1Title);
  divPrice1.appendChild(price1);
  divPrice2.appendChild(price2Title);
  divPrice2.appendChild(price2);
  divPrice3.appendChild(price3Title);
  divPrice3.appendChild(price3);
  divPrice4.appendChild(price4Title);
  divPrice4.appendChild(price4);
  divPrice5.appendChild(price5Title);
  divPrice5.appendChild(price5);
  divPrice6.appendChild(price6Title);
  divPrice6.appendChild(price6);
  orderPrice.appendChild(divPrice1);
  orderPrice.appendChild(divPrice2);
  orderPrice.appendChild(divPrice3);
  orderPrice.appendChild(divPrice4);
  orderPrice.appendChild(divPrice5);
  if (history.newPoint > 0) {
    orderPrice.appendChild(divPrice6);
  }

  return orderPrice;
};

/**
 * 購入明細欄作成
 *
 * @param {*} history
 * @returns
 */
const setOrderDetailArea = (history) => {
  let orderDitail = document.createElement('div');

  orderDitail.className = '_detail';

  // 商品明細
  history.purchaseDetails.forEach(detail => {
    // lineitemsが0の時は表示しない
    if (Number(detail.productQty) > 0) {
      orderDitail.appendChild(makeDetail(history.storeId, detail));
    }
  });

  // shopifyでの購入
  if (isShopifyOrder(history.storeId)) {
    // 配送先
    if (history.shippingAddress) {
      orderDitail.appendChild(makeAddress(history.shippingAddress));
    }
    // お支払い方法
    if (history.paymentMethod) {
      orderDitail.appendChild(makePaymentMethod(history.paymentMethod, history.purchaseTotalAmt));
    }
  }

  return orderDitail;
};

/**
 * 購入明細表示ボタン設定
 *
 * @param {*} orderItem
 * @returns
 */
const setToggleButtonArea = (orderItem) => {
  let orderOpen = document.createElement('div');
  let orderClose = document.createElement('div');
  let spanOpen = document.createElement('span');
  let spanClose = document.createElement('span');

  orderOpen.className = '_open';
  spanOpen.innerText = '＋ 詳しく見る';
  orderClose.className = '_close';
  spanClose.innerText = 'ー 閉じる';

  orderOpen.appendChild(spanOpen);
  orderClose.appendChild(spanClose);
  orderItem.appendChild(orderOpen);
  orderItem.appendChild(orderClose);

  return orderItem;
};

/**
 * 商品明細表示
 *
 * @param {string} storeId
 * @param {*} detail
 * @returns
 */
const makeDetail = (storeId, detail) => {
  let ditailItem = document.createElement('div');
  let detailBrand = document.createElement('h4');
  let detailTitleLink = document.createElement('a');
  let detailTitle = document.createElement('h2');
  let detailColor = document.createElement('p');
  let spanColorTitle = document.createElement('span');
  let spanColor = document.createElement('span');
  let detailSize = document.createElement('p');
  let spanSizeTitle = document.createElement('span');
  let spanSize = document.createElement('span');
  let detailQuantity = document.createElement('p');
  let spanQuantityTitle = document.createElement('span');
  let spanQuantity = document.createElement('span');
  let detailTotal = document.createElement('div');

  ditailItem.className = '_product';
  detailBrand.innerText = detail.brandName;
  detailTitle.innerText = detail.productName;
  spanColorTitle.innerText = 'カラー';
  spanColor.innerText = detail.productColor;
  spanSizeTitle.innerText = 'サイズ';
  spanSize.innerText = (detail.productSize) ? detail.productSize: '';
  spanQuantityTitle.innerText = '点数';
  spanQuantity.innerText = detail.productQty;
  const lineSubtotal = getLineItemPrice(detail);
  detailTotal.innerText = convertMoneyFormat(lineSubtotal);


  ditailItem.appendChild(detailBrand);

  // shopify内商品名に商品詳細ページへのリンクをつける
  if (isShopifyOrder(storeId) && detail.productUrl) {
    detailTitleLink.setAttribute('href', detail.productUrl);
    detailTitleLink.appendChild(detailTitle);
    ditailItem.appendChild(detailTitleLink);
  } else {
    ditailItem.appendChild(detailTitle);
  }

  detailColor.appendChild(spanColorTitle);
  detailColor.appendChild(spanColor);
  ditailItem.appendChild(detailColor);
  detailSize.appendChild(spanSizeTitle);
  detailSize.appendChild(spanSize);
  ditailItem.appendChild(detailSize);
  detailQuantity.appendChild(spanQuantityTitle);
  detailQuantity.appendChild(spanQuantity);
  ditailItem.appendChild(detailQuantity);
  ditailItem.appendChild(detailTotal);

  return ditailItem;
};

/**
 * 配送先欄作成
 *
 * @param {*} address
 * @returns
 */
const makeAddress = (address) => {
  let sub1 = document.createElement('div');
  let sub1Title = document.createElement('h4');
  let sub1Info = document.createElement('p');
  let span1 = document.createElement('span');
  let span2 = document.createElement('span');
  let span3 = document.createElement('span');
  let span4 = document.createElement('span');
  let br1 = document.createElement('br');
  let br2 = document.createElement('br');
  let br3 = document.createElement('br');

  sub1.className = '_sub';
  sub1Title.innerText = '配送先';
  span1.innerText = `〒${address.zip}`;
  span1.setAttribute('wovn-ignore', '');
  span2.innerText = address.province + address.city + address.address1 + address.address2;
  span2.setAttribute('wovn-ignore', '');
  span3.innerText = `${address.fullName}様`;
  span3.setAttribute('wovn-ignore', '');
  span4.innerText = `Tel. ${address.phone}`;

  sub1Info.appendChild(span1);
  sub1Info.appendChild(br1);
  sub1Info.appendChild(span2);
  sub1Info.appendChild(br2);
  sub1Info.appendChild(span3);
  sub1Info.appendChild(br3);
  sub1Info.appendChild(span4);
  sub1.appendChild(sub1Title);
  sub1.appendChild(sub1Info);

  return sub1;
};

/**
 * 支払方法欄作成
 *
 * @param {*} paymentMethod
 * @param {int} purchaseTotalAmt
 * @returns
 */
const makePaymentMethod = (paymentMethod, purchaseTotalAmt) => {
  let sub2 = document.createElement('div');
  let sub2Title = document.createElement('h4');
  let sub2Info = document.createElement('p');
  let span1 = document.createElement('span');
  let span2 = document.createElement('span');
  let span3 = document.createElement('span');
  let br1 = document.createElement('br');
  let br2 = document.createElement('br');

  sub2.className = '_sub';
  sub2Title.innerText = 'お支払い方法';
  if(paymentMethod.gatewayDisplayName == "" && purchaseTotalAmt == 0){
    span1.innerText = "ポイント支払い"
  } else if (paymentMethod.gatewayDisplayName.toLowerCase().includes('paypay(オンライン決済) - sbps')) {
    span1.innerText = "PayPay";
  } else if(paymentMethod.gatewayDisplayName == 'paypal'){
    span1.innerText = "PayPal"
  }else if(paymentMethod.gatewayDisplayName == "Shopify payments" || paymentMethod.gatewayDisplayName.indexOf('SBPS') || paymentMethod.gatewayDisplayName.indexOf('Amazon')){
    span1.innerText = "クレジットカード"
  }
  sub2Info.appendChild(span1);

  /*if (paymentMethod.gatewayDisplayName == 'Shopify payments' || paymentMethod.gatewayDisplayName == 'SBPS') {
    span2.innerText = `下4桁 ${paymentMethod.creditCardLastFourDigits}`;
    span3.innerText = '一括払い';
    sub2Info.appendChild(br1);
    sub2Info.appendChild(span2);
    sub2Info.appendChild(br2);
    sub2Info.appendChild(span3);
  }*/

  sub2.appendChild(sub2Title);
  sub2.appendChild(sub2Info);

  return sub2;
};

/**
 * 表示用明細金額取得
 *
 * @param {*} history
 * @returns
 */
const getLineItemPrice = (detail) => {
  return new Decimal(detail.productPrice).times(detail.productQty).toDP(0, Decimal.ROUND_DOWN).toNumber();
};

/**
 * 配送状況ラベル作成
 *
 * @param {*} history
 * @returns
 */
const getFullfilmentStates = (history) => {
  if (history.fulfillmentStatus == 'fulfilled') {
    return '発送済み'
  }

  if (history.fulfillmentStatus == 'unfulfilled') {
    return '発送準備中'
  }

  return ' - ';
};

/**
 * 獲得ポイントラベル取得
 *
 * @param {*} history
 * @returns
 */
const getPointLabel = (history) => {
  // shopify以外の注文
  if (!isShopifyOrder(history.storeId)) {
    return '獲得ポイント';
  }

  // キャンセル or 返品注文
  if (isCancelOrder(history.isStatus)) {
    return '獲得予定ポイント';
  }

  // crmのnewPointが更新されている
  if (history.isGrantedPoint) {
    return '獲得ポイント';
  }

  // 出荷済かつポイント0の場合
  if (history.fulfillmentStatus == 'fulfilled' && history.newPoint === 0) {
    return '獲得ポイント';
  }

  return '獲得予定ポイント';
}

/**
 * 獲得ポイント（newPoint）の値を計算する
 *
 * @param {*} history
 * @returns
 */
const setNewPoint = (history) => {
  // ポイント付与済またはshopify以外の注文
  if (history.newPoint > 0 || !isShopifyOrder(history.storeId)) {
    return history.newPoint;
  }
  else if (history.waitingPoint > 0) {
    return history.waitingPoint;
  }

  const startDate = new Date('2023/03/22 00:00:00');
  const orderDate = new Date(history.purchaseDate);
  // 注文日が2023/03/22以降
  if (orderDate < startDate) {
    return 0;
  }

  return calcGetPoint(history);
}

/**
 * 利用ポイントの表示
 *
 * @param {*} history
 * @returns
 */
const setUsedPoint = (history) => {
  if (history.usedPoint == 0) {
    return 'なし';
  }

  const usedPoint = convertMoneyFormat(history.usedPoint);

  // 返品
  if (isCancelOrder(history.isStatus)) {
    return usedPoint.replace('-','');
  }

  return `-${usedPoint}`;
}

/**
 * 消費税の表示
 *
 * @param {*} history
 * @returns
 */
const setTaxPrice = (history) => {

  const taxPrice = convertMoneyFormat(history.tax);

  // POS注文かつキャンセル注文の場合
  if (!isShopifyOrder(history.storeId) && isCancelOrder(history.isStatus)) {
    // 返品かつ消費税に-（マイナス）がすでに含まれていたら
    return taxPrice.includes("-") ? `${taxPrice}` : `-${taxPrice}`;
  }

  return `${taxPrice}`;
}

/* Pagenation */

const setOrderHistoryItemList = (records,year,currentPage) => {

  if (records == 0) {
    let pageNav = document.getElementById('pagination'),
    pageNavBottom = document.getElementById('pagination_bottom');
    pageNav.innerHTML = '';
    pageNavBottom.innerHTML = ''; 
  }else{
  // 表示件数と初期のページ数設定
  const itemsPerPage = 20;
  
  // 総ページ数を計算
  const totalPages = Math.ceil(records / itemsPerPage);

    
  generatePaginationLinks(totalPages,year,currentPage);
  // obj = document.querySelector('#pagination .pageNumLinkButton[data-rel="'+currentPage+'"]');
  // console.log(obj);
  // changePageNav(obj,year,totalPages,currentPage);    
  }  
};

// ナビゲーション追加
function generatePaginationLinks(totalPages,year,currentPage) {
  totalcount = totalPages;
  var HTML = "";
  //print next button
  if (totalcount > 0){
      HTML += "<li style=\"display:none;\" class=\"pageLinkButton historyPrevBtn\" onclick=\"changePageNav(this," + year + "," + totalcount + "," + currentPage + ")\" data-current=\"1\" data-rel=\"0\"><svg width=\"6\" height=\"12\" viewBox=\"0 0 6 12\" fill=\"none\"><path d=\"M5 11L1 6L5 1\" stroke=\"#333333\"></path></svg></li>";
  }  
  if (totalcount <= 6) {
   for (i = 1; i <= totalcount; i++) {
      if (i == 1){
        HTML += "<li class=\"pageLinkButton pageNumLinkButton active\" onclick=\"changePageNav(this," + year + "," + totalcount + "," + currentPage + ")\" data-current=\"1\" data-rel=\"1\"><span>" + (1) + "</span></li>";
      }else{
        HTML += addButton(i);          
      }
     }
  } else {  
      // Always print first page button
      //HTML += addButton("1");
      HTML += "<li class=\"pageLinkButton pageNumLinkButton active\" onclick=\"changePageNav(this," + year + "," + totalcount + "," + currentPage + ")\" data-current=\"1\" data-rel=\"1\"><span>" + (1) + "</span></li>";  
      // Print "..." only if currentPage is > 3
      if (currentPage > 3) {
          HTML += "...";
      }  
      // special case where last page is selected...
      if (currentPage == totalcount) {
          HTML += addButton(Number(currentPage) - 2);
      }  
      // Print previous number button if currentPage > 2
      if (currentPage > 2) {
         HTML += addButton(Number(currentPage) - 1);
      }  
      //Print current page number button as long as it not the first or last page
      if (currentPage != 1 && currentPage != totalcount) {
         HTML += addButton(currentPage);
      }  
      //print next number button if currentPage < lastPage - 1
      if (currentPage < Number(totalcount) - 1) {
          HTML += addButton(Number(currentPage) + 1);
      }  
      // special case where first page is selected...
      if (currentPage == 1) {
          HTML += addButton(Number(currentPage) + 2);
      }  
      //print "..." if currentPage is < lastPage -2
      if (currentPage < Number(totalcount) - 2) {
         HTML += "...";
      }  
      //Always print last page button if there is more than 1 page
      HTML += addButton(totalcount);   
  }
  //print next button
  if (totalcount > 0){
      HTML += "<li class=\"pageLinkButton historyNextBtn\" onclick=\"changePageNav(this," + year + "," + totalcount + "," + currentPage + ")\" data-current=\"1\" data-rel=\"2\"><svg width=\"6\" height=\"12\" viewBox=\"0 0 6 12\" fill=\"none\"><path d=\"M1 1L5 6L0.999999 11\" stroke=\"#333333\"></path></svg></li>";
  }   
  document.getElementById('pagination').innerHTML = HTML;
  document.getElementById('pagination_bottom').innerHTML = HTML;

  
  function addButton(number) {
      return "<li class=\"pageLinkButton pageNumLinkButton\" onclick=\"changePageNav(this," + year + "," + totalcount + "," + number + ")\" data-current=\"1\" data-rel=\"" + number + "\"><span>" + (number) + "</span></li>";
  }
  const elems = document.querySelectorAll('.pageLinkButton'),
    prev = document.querySelector('#pagination .historyPrevBtn'),
    prevBottom = document.querySelector('#pagination_bottom .historyPrevBtn'),
    next = document.querySelector('#pagination .historyNextBtn'),
    nextBottom = document.querySelector('#pagination_bottom .historyNextBtn'),
    targetLi = document.querySelector('#pagination .pageNumLinkButton[data-rel="'+currentPage+'"]'),
    targetLiBottom = document.querySelector('#pagination_bottom .pageNumLinkButton[data-rel="'+currentPage+'"]');
  for (var i = 0; i < elems.length; i++) {
    elems[i].classList.remove('active');
    elems[i].dataset.current = currentPage;
  }
  targetLi.classList.add('active');
  targetLiBottom.classList.add('active');

  
   //print prev button
   if (currentPage == 1){
       prev.style.display ="none";
       prev.dataset.rel = 0;
       prevBottom.style.display ="none";
       prevBottom.dataset.rel = 0;
   } else {
       prev.style.display ="flex";
       prev.dataset.rel = Number(currentPage) - 1;
       prevBottom.style.display ="flex";
       prevBottom.dataset.rel = Number(currentPage) - 1;     
   }
   if (Number(totalcount) - Number(currentPage) == 0){
       next.style.display ="none";
       next.dataset.rel = totalcount;
       nextBottom.style.display ="none";
       nextBottom.dataset.rel = totalcount;     
   } else {
       next.style.display ="flex";
       next.dataset.rel = Number(currentPage) + 1;
       nextBottom.style.display ="flex";
       nextBottom.dataset.rel = Number(currentPage) + 1;
   }
  
}
function changePageNav(obj,year,totalcount,currentPage){
  targetPage = obj.dataset.rel;
  generatePaginationLinks(totalcount,year,targetPage);
  setOrderHistory(year,targetPage,currentPage);
 
  var element = document.getElementById("shopify-section-header");
  var rect = element.getBoundingClientRect();
  document.documentElement.scrollTop = rect.top;
  
}